var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLockOpen = function SvgLockOpen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6100",
    "data-name": "Grupo 6100",
    transform: "translate(0 -1010)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2310",
    "data-name": "Ret\\xE2ngulo 2310",
    width: 88,
    height: 88,
    rx: 20,
    transform: "translate(0 1010)",
    fill: "#ffbaac"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lock_open_50dp_5F6368",
    transform: "translate(17 1027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8563",
    "data-name": "Caminho 8563",
    d: "M0,0H55V55H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_51",
    "data-name": "Subtra\\xE7\\xE3o 51",
    d: "M11280.085,18825.125h-27.5a4.589,4.589,0,0,1-4.583-4.584v-22.918a4.588,4.588,0,0,1,4.583-4.582h20.854v-4.584a7.1,7.1,0,1,0-14.206,0h-4.356a11.459,11.459,0,0,1,22.919,0v4.584h2.291a4.588,4.588,0,0,1,4.583,4.582v22.918A4.589,4.589,0,0,1,11280.085,18825.125Zm-13.087-22.914a6.5,6.5,0,1,0,6.5,6.5A6.5,6.5,0,0,0,11267,18802.211Z",
    transform: "translate(-11239 -18774.709)",
    fill: "#fff"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLockOpen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock-open.64060a4e.svg";
export { ForwardRef as ReactComponent };